export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header with gradient accent */}
      <div className="border-b border-[#1A1A1A] bg-gradient-to-r from-[#0A0A0A] via-[#0F0F0F] to-[#0A0A0A]">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex items-center gap-3 mb-2">
            <a 
              href="/" 
              className="text-[#3ECF8E] hover:text-[#35b87d] transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </a>
            <h1 className="text-4xl font-bold text-white">Politique de Confidentialité</h1>
          </div>
          <p className="text-gray-400 text-sm ml-9">Dernière mise à jour : 11/02/2026</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-[#0A0A0A] border border-[#1A1A1A] rounded-2xl p-10 shadow-2xl">
          <div className="prose prose-invert max-w-none space-y-10">
            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                1. Qui sommes-nous ?
              </h2>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Avocat AI est Notre plateforme juridique intelligente, propulsée par l'intelligence artificielle, permet d'obtenir des réponses claires, fiables et instantanées à vos questions juridiques, elle facilite l'accès au droit en fournissant des informations juridiques précises en quelques secondes. Grâce à une technologie avancée et une base de connaissances rigoureusement sélectionnée, notre solution simplifie la compréhension des textes légaux, oriente les utilisateurs dans leurs démarches et contribue à une meilleure prise de décision, en toute sécurité et confidentialité.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                2. Quelles données collectons-nous ?
              </h2>
              <p className="text-gray-300 mb-3 text-[15px]">Tu nous fournis :</p>
              <ul className="list-disc list-inside text-gray-300 mb-6 space-y-2 ml-4 text-[15px]">
                <li>Ton email et ton nom (si tu crées un compte)</li>
              </ul>
              <p className="text-gray-300 mb-3 text-[15px]">On collecte automatiquement :</p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 text-[15px]">
                <li>Ton adresse IP</li>
                <li>La date et l'heure de tes connexions</li>
              </ul>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                3. Pourquoi on collecte ces données ?
              </h2>
              <div className="overflow-x-auto bg-[#0F0F0F] border border-[#1A1A1A] rounded-lg">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-[#0A0A0A] border-b border-[#1A1A1A]">
                      <th className="px-6 py-4 text-left text-white font-semibold text-sm">Donnée</th>
                      <th className="px-6 py-4 text-left text-white font-semibold text-sm">Pourquoi ?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-[#1A1A1A] hover:bg-[#0F0F0F] transition-colors">
                      <td className="px-6 py-4 text-gray-300 text-sm">Email, compte</td>
                      <td className="px-6 py-4 text-gray-300 text-sm">Pour te connecter et gérer ton abonnement</td>
                    </tr>
                    <tr className="border-b border-[#1A1A1A] hover:bg-[#0F0F0F] transition-colors">
                      <td className="px-6 py-4 text-gray-300 text-sm">IP, logs</td>
                      <td className="px-6 py-4 text-gray-300 text-sm">Pour sécuriser l'application</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                4. Conservation des données
              </h2>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 text-[15px]">
                <li>Comptes actifs : conservés tant que tu utilises le service</li>
                <li>Données de connexion : conservées 1 an</li>
                <li>Après ces délais, tout est supprimé.</li>
              </ul>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                5. Attention - Données sensibles
              </h2>
              <div className="bg-[#0F0F0F] border-l-4 border-[#3ECF8E] p-4 rounded-r-lg mb-4">
                <p className="text-gray-300 mb-3 text-[15px]">Ne partage JAMAIS ces informations dans tes conversations :</p>
                <ul className="list-disc list-inside text-gray-300 mb-3 space-y-2 ml-4 text-[15px]">
                  <li>Numéro de carte d'identité ou passeport</li>
                  <li>Informations médicales</li>
                  <li>Opinions politiques ou religieuses</li>
                  <li>Données bancaires</li>
                </ul>
              </div>
              <p className="text-gray-300 mb-2 text-[15px]">
                <strong className="text-white">Pourquoi ?</strong> Parce qu'on ne veut pas avoir à gérer ce type de données, et c'est plus sûr pour toi.
              </p>
              <p className="text-gray-300 text-[15px]">
                Si tu en envoies quand même, on les supprime automatiquement dès qu'on les détecte.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                6. Tes droits
              </h2>
              <p className="text-gray-300 mb-4 text-[15px]">Tu peux à tout moment :</p>
              <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2 ml-4 text-[15px]">
                <li>Voir les données qu'on a sur toi</li>
                <li>Demander une correction</li>
                <li>Demander la suppression de tes données</li>
                <li>Retirer ton consentement</li>
              </ul>
              <p className="text-gray-300 text-[15px]">
                <strong className="text-white">Comment ?</strong> Envoie-nous un email. On traite ta demande sous 30 jours maximum.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                7. Sécurité
              </h2>
              <p className="text-gray-300 mb-4 text-[15px] leading-relaxed">
                Tous tes échanges sont chiffrés (SSL). Tes questions et les réponses de l'IA voyagent de manière cryptée entre ton appareil et nos serveurs, comme un tunnel privé que personne ne peut ouvrir. Seuls toi et l'application avez la clé.
              </p>
              <p className="text-gray-300 text-[15px] leading-relaxed">
                Tes conversations sont stockées de façon sécurisée et ne sont accessibles qu'aux personnes strictement habilitées à gérer le service. Nous ne partageons aucune donnée avec des annonceurs ou des tiers commerciaux.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                8. Consentement
              </h2>
              <p className="text-gray-300 text-[15px] leading-relaxed">
                La plateforme est actuellement mise à disposition gratuitement. Les données que vous saisissez peuvent être partagées avec des services d'intelligence artificielle externes afin de générer des réponses et améliorer le fonctionnement de la plateforme. L'utilisation gratuite implique que vos données sont uniquement utilisées dans ce cadre et ne servent pas à d'autres fins.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                9. Modifications
              </h2>
              <p className="text-gray-300 text-[15px] leading-relaxed">
                On peut mettre à jour cette politique. Si on change des choses importantes, on te préviendra par email ou par notification.
              </p>
            </section>
          </div>

          {/* Action Buttons */}
          <div className="mt-12 pt-8 border-t border-[#1A1A1A]">
            <div className="flex flex-col sm:flex-row gap-4 mb-6">
              <a
                href="/terms"
                className="flex-1 px-6 py-3.5 bg-[#3ECF8E] text-white font-medium rounded-lg hover:bg-[#34B27B] transition-all duration-200 text-center shadow-lg shadow-[#3ECF8E]/20 hover:shadow-[#3ECF8E]/30 hover:scale-[1.02] active:scale-[0.98]"
              >
                Accepter
              </a>
              <a
                href="/"
                className="flex-1 px-6 py-3.5 bg-[#0F0F0F] border border-[#1A1A1A] text-white font-medium rounded-lg hover:bg-[#1A1A1A] hover:border-[#2A2A2A] transition-all duration-200 text-center hover:scale-[1.02] active:scale-[0.98]"
              >
                Refuser
              </a>
            </div>
            <div className="text-center">
              <a 
                href="/" 
                className="inline-flex items-center gap-2 text-[#3ECF8E] hover:text-[#35b87d] transition-colors font-medium text-sm"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Retour à l'accueil
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
